document.addEventListener("DOMContentLoaded", function () {
  const source = document.querySelector("#product-options");
  const target = document.querySelector('[name="fields[products][]"]');

  setTimeout(() => {
    if (source && target) {
      const validOptions = [...source.querySelectorAll("span")].map((span) => ({
        id: span.getAttribute("item"),
        slug: span.textContent.trim(),
      }));

      const validIds = validOptions.map((opt) => opt.id);
      // Remove options not in the list of valid IDs
      [...target.options].forEach((opt) => {
        if (opt.value && !validIds.includes(opt.value)) {
          opt.remove();
        }
      });

      // Auto-select based on URL slug match
      const path = window.location.pathname.split("/").filter(Boolean).pop();
      const matched = validOptions.find((opt) => opt.slug === path);

      if (matched) {
        const matchingOption = [...target.options].find(
          (opt) => opt.value === matched.id
        );
        if (matchingOption) {
          matchingOption.selected = true;
        }
      }
    }
  }, 100);
});
